import axios from '@/lib/axios';
import ResetPasswordParams from '../types/ResetPasswordParams';

const resetPassword = (data: ResetPasswordParams) => {
  return axios.put('/customer/forgot_password', data);
}

export default resetPassword;